"use strict";
'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useTabsList = useTabsList;
var React = _interopRequireWildcard(require("react"));
var _Tabs = require("../Tabs");
var _useTabsList = require("./useTabsList.types");
var _useCompound = require("../useCompound");
var _useList = require("../useList");
var _tabsListReducer = require("./tabsListReducer");
/**
 *
 * Demos:
 *
 * - [Tabs](https://mui.com/base-ui/react-tabs/#hooks)
 *
 * API:
 *
 * - [useTabsList API](https://mui.com/base-ui/react-tabs/hooks-api/#use-tabs-list)
 */ function useTabsList(parameters) {
    var externalRef = parameters.rootRef;
    var _ref = (0, _Tabs.useTabsContext)(), _ref_direction = _ref.direction, direction = _ref_direction === void 0 ? 'ltr' : _ref_direction, onSelected = _ref.onSelected, _ref_orientation = _ref.orientation, orientation = _ref_orientation === void 0 ? 'horizontal' : _ref_orientation, value = _ref.value, registerTabIdLookup = _ref.registerTabIdLookup, selectionFollowsFocus = _ref.selectionFollowsFocus;
    var _ref1 = (0, _useCompound.useCompoundParent)(), subitems = _ref1.subitems, compoundComponentContextValue = _ref1.contextValue;
    var tabIdLookup = React.useCallback(function(tabValue) {
        var _subitems_get;
        return (_subitems_get = subitems.get(tabValue)) === null || _subitems_get === void 0 ? void 0 : _subitems_get.id;
    }, [
        subitems
    ]);
    registerTabIdLookup(tabIdLookup);
    var subitemKeys = React.useMemo(function() {
        return Array.from(subitems.keys());
    }, [
        subitems
    ]);
    var getTabElement = React.useCallback(function(tabValue) {
        var _subitems_get;
        if (tabValue == null) {
            return null;
        }
        var _subitems_get_ref_current;
        return (_subitems_get_ref_current = (_subitems_get = subitems.get(tabValue)) === null || _subitems_get === void 0 ? void 0 : _subitems_get.ref.current) !== null && _subitems_get_ref_current !== void 0 ? _subitems_get_ref_current : null;
    }, [
        subitems
    ]);
    var isRtl = direction === 'rtl';
    var listOrientation;
    if (orientation === 'vertical') {
        listOrientation = 'vertical';
    } else {
        listOrientation = isRtl ? 'horizontal-rtl' : 'horizontal-ltr';
    }
    var handleChange = React.useCallback(function(event, newValue) {
        var _newValue_;
        onSelected(event, (_newValue_ = newValue[0]) !== null && _newValue_ !== void 0 ? _newValue_ : null);
    }, [
        onSelected
    ]);
    var controlledProps = React.useMemo(function() {
        if (value === undefined) {
            return {};
        }
        return value != null ? {
            selectedValues: [
                value
            ]
        } : {
            selectedValues: []
        };
    }, [
        value
    ]);
    var isItemDisabled = React.useCallback(function(item) {
        var _subitems_get;
        var _subitems_get_disabled;
        return (_subitems_get_disabled = (_subitems_get = subitems.get(item)) === null || _subitems_get === void 0 ? void 0 : _subitems_get.disabled) !== null && _subitems_get_disabled !== void 0 ? _subitems_get_disabled : false;
    }, [
        subitems
    ]);
    var _ref2 = (0, _useList.useList)({
        controlledProps: controlledProps,
        disabledItemsFocusable: !selectionFollowsFocus,
        focusManagement: 'DOM',
        getItemDomElement: getTabElement,
        isItemDisabled: isItemDisabled,
        items: subitemKeys,
        rootRef: externalRef,
        onChange: handleChange,
        orientation: listOrientation,
        reducerActionContext: React.useMemo(function() {
            return {
                selectionFollowsFocus: selectionFollowsFocus || false
            };
        }, [
            selectionFollowsFocus
        ]),
        selectionMode: 'single',
        stateReducer: _tabsListReducer.tabsListReducer
    }), listContextValue = _ref2.contextValue, dispatch = _ref2.dispatch, getListboxRootProps = _ref2.getRootProps, _ref_state = _ref2.state, highlightedValue = _ref_state.highlightedValue, selectedValues = _ref_state.selectedValues, mergedRootRef = _ref2.rootRef;
    React.useEffect(function() {
        if (value === undefined) {
            return;
        }
        // when a value changes externally, the highlighted value should be synced to it
        if (value != null) {
            dispatch({
                type: _useTabsList.TabsListActionTypes.valueChange,
                value: value
            });
        }
    }, [
        dispatch,
        value
    ]);
    var getRootProps = function() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _object_spread_props(_object_spread({}, externalProps, getListboxRootProps(externalProps)), {
            'aria-orientation': orientation === 'vertical' ? 'vertical' : undefined,
            role: 'tablist'
        });
    };
    var contextValue = React.useMemo(function() {
        return _object_spread({}, compoundComponentContextValue, listContextValue);
    }, [
        compoundComponentContextValue,
        listContextValue
    ]);
    var _selectedValues_;
    return {
        contextValue: contextValue,
        dispatch: dispatch,
        getRootProps: getRootProps,
        highlightedValue: highlightedValue,
        isRtl: isRtl,
        orientation: orientation,
        rootRef: mergedRootRef,
        selectedValue: (_selectedValues_ = selectedValues[0]) !== null && _selectedValues_ !== void 0 ? _selectedValues_ : null
    };
}
